import React from "react";

interface BaseIconProps {
  isActive?: boolean;
  className?: string;
}

export default function AllToFront({ isActive, className }: BaseIconProps) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="all-to-front"
    >
      <path
        d="M18.2 2.24512H7.4C4.43 2.24512 2 4.67512 2 7.64512V18.4451C2 21.4151 4.43 23.8451 7.4 23.8451H18.2C21.17 23.8451 23.6 21.4151 23.6 18.4451V7.64512C23.6 4.67512 21.17 2.24512 18.2 2.24512Z"
        fill="#343A40"
      />
      <path
        d="M25.4001 31.0453H14.6001C11.6301 31.0453 9.20007 28.6153 9.20007 25.6453H11.0001C11.0001 27.6253 12.6201 29.2453 14.6001 29.2453H25.4001C27.3801 29.2453 29.0001 27.6253 29.0001 25.6453V14.8453C29.0001 12.8653 27.3801 11.2453 25.4001 11.2453V9.44531C28.3701 9.44531 30.8001 11.8753 30.8001 14.8453V25.6453C30.8001 28.6153 28.3701 31.0453 25.4001 31.0453Z"
        fill="#343A40"
        stroke="#343A40"
      />
      <path
        d="M32.6001 38.245H21.8001C19.2801 38.245 17.0301 36.445 16.4901 33.925C16.4001 33.565 16.4001 33.205 16.4001 32.845H18.2001C18.2001 33.115 18.2001 33.295 18.2901 33.565C18.6501 35.185 20.0901 36.445 21.8001 36.445H32.6001C34.5801 36.445 36.2001 34.825 36.2001 32.845V22.045C36.2001 20.335 35.0301 18.895 33.3201 18.535C33.0501 18.445 32.8701 18.445 32.6001 18.445V16.645C32.9601 16.645 33.3201 16.645 33.6801 16.735C36.2001 17.275 38.0001 19.435 38.0001 22.045V32.845C38.0001 35.815 35.5701 38.245 32.6001 38.245Z"
        fill="#343A40"
        stroke="#343A40"
      />
    </svg>
  );
}
